var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/publishingSettings.dd40a9e5.png","uri@2x": __webpack_public_path__ + "static/media/publishingSettings.9e3d9aba.png","uri@3x": __webpack_public_path__ + "static/media/publishingSettings.2b7ce54b.png",
    width: 20,
    height: 20
});